import { render, staticRenderFns } from "./ClientBillingHistory.vue?vue&type=template&id=57225358&scoped=true&v-if=clientId"
import script from "./ClientBillingHistory.vue?vue&type=script&lang=js"
export * from "./ClientBillingHistory.vue?vue&type=script&lang=js"
import style0 from "./ClientBillingHistory.vue?vue&type=style&index=0&id=57225358&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57225358",
  null
  
)

export default component.exports